import { NEARBY_STORES, DISTANCE_GOOGLE_API, STORE_STATUS, RESET_STORES, STORE_AVAILABLE_TIME_SLOTS_REQUEST, SET_ON_PRE_30_MIN_POPUP_SCREENCHECK, STORE_SCHEDULE_DATA, GET_STORE_STATUS_ON_TIME, GET_STORES, SET_STORE_FAVOURITE, SET_STORE_UN_FAVOURITE, SET_GEOHASH_COUNT, SELECTED_DISPOSITION, STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST, STORE_AVAILABLE_TIME_SLOTS_SUCCESS, ORDER_READY_DATETIME_UPDATE, GET_STORE_DETAILS, GET_RESTAURANT_DETAILS, GET_CONTACT_US_RESTAURANT_DETAILS, RESET_STORE_DETAILS, RESET_RESTAURANT_DETAILS, SET_DISPOSITION, RESET_DISPOSITION, SHOW_DISPOSITION_MODAL, SET_ADDITIONAL_ADDRESS, SET_STATE_FOR_SELECTKFC, USER_LOCATION, USER_LOCATION_DENIED, STORE_LOCATION_SUCCESS, RESET_USER_LOCATION, SET_ERROR_MESSAGE, FAVORITE_STORE_STATUS, GET_STORES_DETAILS_CONTENT_FULL, SET_ON_FIND_A_KFC_PAGE, SET_ROOT, SET_STORE_OPENTIME_CLOSEDTIME, SET_STORE_PLACE_ID, USER_LOCATION_ACCESS_STATUS, RESET_STORE_DATA, SET_ON_PRE_45_MIN_POPUP_SCREENCHECK, } from '../../constants';
export function getNearbyStores(geohash, updatedStores) {
    return {
        type: NEARBY_STORES,
        payload: { geohash, updatedStores },
    };
}
export function getDistanceGoogleApi({ origin, destination, store, googleConfig, distanceMetrics, setStatusFlag = false, }) {
    return {
        type: DISTANCE_GOOGLE_API,
        payload: {
            origin,
            destination,
            store,
            googleConfig,
            distanceMetrics,
            setStatusFlag,
        },
    };
}
export function getBulkStoreStatus({ data, store, tenantId, setStatusFlag = false, isFavoritePage }, sucessCallback) {
    return {
        type: STORE_STATUS,
        payload: { data, store, tenantId, setStatusFlag, isFavoritePage },
        sucessCallback,
    };
}
export function getFavoriteBulkStoreStatus({ data, store, tenantId, setStatusFlag = false, isFavoritePage }, sucessCallback) {
    return {
        type: FAVORITE_STORE_STATUS,
        payload: { data, store, tenantId, setStatusFlag, isFavoritePage, isFavoriteStore: true },
        sucessCallback,
    };
}
export function resetStores() {
    return {
        type: RESET_STORES,
    };
}
export function getAvailableTimeSlotsApiSaga({ data, tenantId }, sucessCallBack = () => { }, errorCallBack = () => { }) {
    return {
        type: STORE_AVAILABLE_TIME_SLOTS_REQUEST,
        payload: { data, tenantId },
        sucessCallBack,
        errorCallBack,
    };
}
export function getAvailableAllTimeSlotsApiSaga({ data, tenantId }, sucessCallBack = () => { }, errorCallBack = () => { }) {
    return {
        type: STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST,
        payload: { data, tenantId },
        sucessCallBack,
        errorCallBack,
    };
}
export function storeScheduleOrderInfoInStore(payload) {
    return {
        type: STORE_SCHEDULE_DATA,
        payload,
    };
}
export function setSelectedDispostion(payload) {
    return {
        type: SELECTED_DISPOSITION,
        payload,
    };
}
export function getStoreStatusForTimeSaga({ data, tenantId }, successCallback = () => { }, errorCallback = () => { }) {
    return {
        type: GET_STORE_STATUS_ON_TIME,
        payload: { data, tenantId },
        successCallback,
        errorCallback,
    };
}
export function orderReadyDateTimeUpdate({ params, tenantId, postBody, orderReadyDateTimeUpdateSuccessCallback, orderReadyDateTimeUpdateErrorCallback, }) {
    return {
        type: ORDER_READY_DATETIME_UPDATE,
        payload: { params, tenantId, postBody },
        successCallBack: orderReadyDateTimeUpdateSuccessCallback,
        errorCallBack: orderReadyDateTimeUpdateErrorCallback,
    };
}
export function getStores(isLoading) {
    return {
        type: GET_STORES,
        isLoading,
    };
}
export function setStoresFavourite({ data, tenantId, customerId, dispatch, bearerToken }, successCallBack = () => { }, errorCallBack = () => { }) {
    return {
        type: SET_STORE_FAVOURITE,
        payload: { data, tenantId, customerId, dispatch, bearerToken },
        successCallBack: successCallBack,
        errorCallBack: errorCallBack,
    };
}
export function setStoresUnFavourite({ tenantId, customerId, storeId, dispatch }, successCallBack = () => { }, errorCallBack = () => { }) {
    return {
        type: SET_STORE_UN_FAVOURITE,
        payload: { tenantId, customerId, storeId, dispatch },
        successCallBack: successCallBack,
        errorCallBack: errorCallBack,
    };
}
export function setGeoHashCount(count) {
    return {
        type: SET_GEOHASH_COUNT,
        count,
    };
}
export function clearStoreTimeSlotAction() {
    return {
        type: STORE_AVAILABLE_TIME_SLOTS_SUCCESS,
        response: {},
    };
}
export function getStoreDetails(payload, sucessCallback, errorCallback) {
    return {
        type: GET_STORE_DETAILS,
        payload,
        sucessCallback,
        errorCallback,
    };
}
export function getRestaurantDetails(payload, sucessCallback, errorCallback) {
    return {
        type: GET_RESTAURANT_DETAILS,
        payload,
        sucessCallback,
        errorCallback,
    };
}
export function getContactUSRestaurantDetails(payload, sucessCallback = () => { }, errorCallback = () => { }) {
    return {
        type: GET_CONTACT_US_RESTAURANT_DETAILS,
        payload,
        sucessCallback,
        errorCallback,
    };
}
export function resetStoreDetails() {
    return {
        type: RESET_STORE_DETAILS,
    };
}
export function resetRestaurantDetails() {
    return {
        type: RESET_RESTAURANT_DETAILS,
    };
}
export function setDispositionAction(service) {
    return {
        type: SET_DISPOSITION,
        service,
    };
}
export function resetDisposition() {
    return {
        type: RESET_DISPOSITION,
    };
}
export function setShowDispositionModal(showModal) {
    return {
        type: SHOW_DISPOSITION_MODAL,
        showModal,
    };
}
export function setAdditionalAddress(value, additionalAddress) {
    return {
        type: SET_ADDITIONAL_ADDRESS,
        value,
        additionalAddress,
    };
}
export function setShowKfcPage(boolean) {
    return {
        type: SET_STATE_FOR_SELECTKFC,
        boolean,
    };
}
export function userLocation(payload) {
    return {
        type: USER_LOCATION,
        payload,
    };
}
export function setRoot(payload) {
    return {
        type: SET_ROOT,
        payload,
    };
}
export function userLocationDenied(payload) {
    return {
        type: USER_LOCATION_DENIED,
        payload,
    };
}
export function storeWithUserLocation(payload, maxDistance, setStoreError) {
    return {
        type: STORE_LOCATION_SUCCESS,
        payload: { ...payload, maxDistance, setStoreError },
    };
}
export function resetUserLocation() {
    return {
        type: RESET_USER_LOCATION,
    };
}
export function setErrorMessage(bool) {
    return {
        type: SET_ERROR_MESSAGE,
        bool,
    };
}
export function setStoreClosedAndOpenTime(payload) {
    return {
        type: SET_STORE_OPENTIME_CLOSEDTIME,
        payload,
    };
}
export function detailsContentFull(payload) {
    return {
        type: GET_STORES_DETAILS_CONTENT_FULL,
        payload,
    };
}
export function setNavigatedFromFindAKfc(isFromKFC) {
    return {
        type: SET_ON_FIND_A_KFC_PAGE,
        isFromKFC,
    };
}
export function setOnPre45MinPOPUP(isFromPre) {
    return {
        type: SET_ON_PRE_45_MIN_POPUP_SCREENCHECK,
        isFromPre,
    };
}
export function setOnPre30MinPOPUP(isMin) {
    return {
        type: SET_ON_PRE_30_MIN_POPUP_SCREENCHECK,
        isMin,
    };
}
export function setStorePlaceId(payload) {
    return {
        type: SET_STORE_PLACE_ID,
        payload,
    };
}
export function getUserLocationAccess(payload) {
    return {
        type: USER_LOCATION_ACCESS_STATUS,
        payload,
    };
}
export function resetStoreData() {
    return {
        type: RESET_STORE_DATA,
    };
}
